/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import DeviceModel from 'cio/models/device';
import { PLATFORM_LABELS } from 'cio/utils/push/platforms';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { isEmpty } from '@ember/utils';

const ATTRIBUTES_TO_FILTER = [
  'id',
  '_last_used',
  '_last_status',
  'platform',
  'app_version',
  'device_model',
  'device_os',
  'device_locale',
  'device_manufacturer',
  'push_enabled',
  'cio_sdk_version',
];
interface DeviceRowArgs {
  device: DeviceModel;
  selected: boolean;
  disabled: boolean;
}

export default class DeviceRow extends Component<DeviceRowArgs> {
  @service environment!: EnvironmentService;

  @tracked expanded = false;

  @computed('args.device.attributes.lastStatus')
  get lastStatusIndicatesFailure() {
    let { _last_status: lastStatus } = this.args.device.attributes;
    return lastStatus === 'bounced' || lastStatus === 'suppressed';
  }

  @computed('args.device.{deviceModel,platform}')
  get deviceTitle() {
    let { device_manufacturer: manufacturer } = this.args.device.attributes;
    let { deviceModel, platform } = this.args.device;

    let deviceTitle = deviceModel || `${PLATFORM_LABELS[platform]} Device`;
    if (platform === 'android' && !isEmpty(manufacturer)) {
      deviceTitle = `${manufacturer} ${deviceTitle}`;
    }

    return deviceTitle;
  }

  get workspaceFirstLetter() {
    return this.environment.current.name.charAt(0).toUpperCase();
  }

  @computed('args.device.attributes')
  get customDeviceAttributes() {
    let { attributes } = this.args.device;
    return Object.keys(attributes)
      .filter(this.onlyCustomDeviceAttributes)
      .map((name) => ({ name, value: attributes[name] }));
  }

  get hasCustomDeviceAttributes() {
    return this.customDeviceAttributes.length > 0;
  }

  private onlyCustomDeviceAttributes(attributeName: string) {
    return !ATTRIBUTES_TO_FILTER.includes(attributeName);
  }

  @action
  toggleExpanded() {
    if (this.args.disabled) {
      return;
    }
    this.expanded = !this.expanded;
  }
}
